import locale from './config/locale.config.js';

let targetConfig;
let targetEnv;
let targetLocale;

function setConfig({ config, env, locale }) {
    targetConfig = config;
    targetEnv = env;
    targetLocale = locale;
}

const appSettings = {
    get config() {
        return targetConfig;
    },
    get env() {
        return targetEnv;
    },
    get locale() {
        return targetLocale;
    },
};

export { appSettings };
export { locale };
export { setConfig };
export default appSettings;
